module.exports = __webpack_public_path__ + "static/media/023.b19cd74d.jpg";